var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:{ 'is-loading': _vm.loading },attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){$event.preventDefault();return _vm.doAction.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }